export default "<radio-player>\r\n  \r\n</radio-player>";